export const removeSurroundingQuotes = (maybeQuotedString: string) =>
	maybeQuotedString.replace(/^["']|["']$/g, '');
